import { render } from "./Evaluation.vue?vue&type=template&id=5855504c&scoped=true"
import script from "./Evaluation.vue?vue&type=script&lang=js"
export * from "./Evaluation.vue?vue&type=script&lang=js"

import "./Evaluation.vue?vue&type=style&index=0&id=5855504c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5855504c"]])

export default __exports__